import React, { useRef, useState, useEffect } from "react";
import { connect } from 'react-redux';
import { currentAWERightSidebarType, currentAWERightSidebar, currentAWERightSidebarCloseDatatableReload } from '../../../store/actions';
import AWVApi from '../../../assets/constants/AWVRafservice.Instance';
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';
import Divider from '@mui/material/Divider';
import { useForm, Controller } from "react-hook-form";
import Box from '@mui/material/Box';
import pdfIcon from '../../../assets/images/pdf_icon.png';
import Moment from 'moment';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import Typography from '@material-ui/core/Typography';
import { CircularProgress } from '@material-ui/core';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { styled } from '@mui/material/styles';
import TextField from '@material-ui/core/TextField';
import { toast } from 'react-toastify';
import axios from "axios";
import AWS from 'aws-sdk';
import { event } from "jquery";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import IconButton from "../../layout/aweLayout/IconButton";
import Button from "../../layout/aweLayout/Button";
import CloseIcon from "../../icons/CloseIcon";
import PlusFileIcon from '../../icons/PlusFileIcon';
import {LogFileUploadToS3} from '../../../assets/constants/LogFileUploadToS3'
import { encrypt } from '../../../assets/constants/Encryption';
const aws = require('aws-sdk');

const S3_BUCKET = process.env.REACT_APP_AWE_FILE_UPLOAD_BUCKET;
const REGION = process.env.REACT_APP_REGION;

const StageChange = (props) => {
    const [editFormData, setEditFormData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { register: registerHcc, formState: { errors: errorsHcc }, handleSubmit: handleSubmitHcc, reset: resetHcc, control: controlHcc, setValue: setValueHcc } = useForm();
    const { register, formState: { errors }, handleSubmit, reset, control, getValues, setValue } = useForm();
    const [fileUrl, setFileUrl] = useState();
    const [fileName, setFileName] = useState();
    const [rejectionCodeList, setRejectionCodeList] = useState([]);
    const [editDetailsGridShow, setEditDetailsGridShow] = useState(false);
    const [editHcccDetailsIndex, setEditHcccDetailsIndex] = useState('');
    const [formDataList, setFormDataList] = useState([]);
    const [formSubmitisLoading, setFormSubmitisLoading] = useState(false);
    const [openView, setOpenView] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [currentActionStatus, setCurrentActionStatus] = useState('');
    const [logMessages, setLogMessages] = useState([]); // Array to store log messages
    const writeToLogFile = (message) => {
       setLogMessages(prevLogMessages => [...prevLogMessages, `${new Date().toISOString()} - ${message}`]);
   };
   const [generateLog, setGenerateLog] = useState(false);
   const [onholdPrimaryReasonCode, setOnholdPrimaryReasonCode] = useState('');
   const [secondaryReasonText, setSecondaryReasonText] = useState('');
   const [secondaryReasonCode, setSecondaryReasonCode] = useState('');
   const ACCESS_KEY = localStorage.getItem('access_key');
   const SECRET_ACCESS_KEY = localStorage.getItem('secret_key');
            

    useEffect(() => {
        editLoadFormData(props.awv_backend_id);

    }, [props.awv_backend_id]);

    useEffect(() => {
        if (editFormData?.form_url && editFormData?.form_url != '') {

            aws.config.update({
                accessKeyId: ACCESS_KEY,
                secretAccessKey: SECRET_ACCESS_KEY,
                region: REGION
            });
            const s3d = new aws.S3();
            var credentials = {
                accessKeyId: ACCESS_KEY,
                secretAccessKey: SECRET_ACCESS_KEY
            };
            AWS.config.update({ credentials: credentials, region: process.env.REACT_APP_REGION, signatureVersion: "v4" });
            var s3 = new AWS.S3({
                signatureVersion: "v4"
            });

            let url = editFormData?.form_url
            const [protocol, fullHost, ...pathSegments] = url.split('/');
            const [bucketName, port] = pathSegments[0].split('.');
            const objectKey = pathSegments.slice(1).join('/');
    
            const Key = `${objectKey}`;

            s3.setupRequestListeners = (request) => {
                request.on('build', (req) => {

                    req.httpRequest.headers['x-amz-date'] = process.env.REACT_APP_KeyID;
                });
            }

            var presignedGETURL = s3.getSignedUrl('getObject', {
                Bucket: bucketName,
                Key: Key,
                Expires: 60
            });
            setFileUrl(presignedGETURL);
            axios({
                url: presignedGETURL,
                responseType: "arraybuffer",
                method: "GET",
            }).then((res) => {

                let file = new Blob([res.data], {
                    type: "application/pdf",
                });

                let fileURL = URL.createObjectURL(file);

            }).catch((err) => { console.log("Error while downloading file...") })

        }
    }, [editFormData?.form_url]);

    useEffect(() => {
        if (editFormData?.awv_backend_id && editFormData?.awv_backend_id != '') {
            let controlUser = JSON.parse(localStorage.getItem('controlUser'));

            setValue('role', 2);
            setValue('action_status', 5);
            setValue('reason_code', '');
            setValue('awv_backend_id', editFormData?.awv_backend_id);
            setValue('createdOn', editFormData?.created_on);
            setValue('lob', props?.lobSelect);
            setValue('user_id', controlUser?.user_id);
            setValue('provider_id', controlUser?.user_id);
            setValue('pos_name', (editFormData?.POS) ? editFormData?.POS : "");
            setValue('form_status', props.aweRightSidebarType?.status);
            setValue('cin', editFormData?.cin);
            setValue('member_id', editFormData?.member_id);
            setValue('organisation_id', (editFormData?.organisation_id).toString());
            setValue('payment_year', props.yearSelect);
            setValue('provider_group', editFormData?.provider_group);
            setValue('onhold_status', 'N'); // implemetion pending

        }
    }, [editFormData]);


    const notificationRightDrawer = (open, valueId = '') => {
        props.currentAWERightSidebarType({ 'type': 'notification' });
        props.currentAWERightSidebar(open);
    };
    const notificationRightDrawerNLP = (open, value = '') => {
        setOpenView(true);
        handleCloseAction();
    };
    const handleCloseAction = () => {
        setAnchorEl(null);
    };
    const handleClickOpenView = (value) => {
        setOpenView(true);
        handleCloseAction();
    };
    const handleCloseView = () => {
        setOpenView(false);
        handleCloseAction();
    };

    const editLoadFormData = (value) => {
        writeToLogFile("value...", value);
        var awv_backend_id_en = encrypt(value)
        writeToLogFile("editLoadFormData...");
        writeToLogFile("value after encryption ", value)
        setIsLoading(true);
        writeToLogFile('/get-all-awv-record?payment_year=' + props.yearSelect + '&organisation_id=1&lob=' + props.lobSelect + '&awv_backend_id=' + value + '&iSortCol_0=provider_group&sSortDir_0=asc&iDisplayStart=0&iDisplayLength=1&formAttached=0');
        AWVApi.get('/get-all-awv-record?payment_year=' + props.yearSelect + '&organisation_id=1&lob=' + props.lobSelect + '&awv_backend_id=' + awv_backend_id_en + '&iSortCol_0=provider_group&sSortDir_0=asc&iDisplayStart=0&iDisplayLength=1&formAttached=0')
              .then(res => {
                console.log(res.data);
                if (res.data && res.data[0]) {
                    loadformAWEProcessedRecord(res.data[0].cin, res.data[0].awe_display_id);
                    // alert(JSON.stringify(res.data[0]))
                    setEditFormData(res.data[0]);
                    setEditDetailsGridShow(false);
                    setEditHcccDetailsIndex('');
                    setIsLoading(false);
                    writeToLogFile("response received successfully...");
                } else {
                    setEditFormData();
                    setIsLoading(false);
                    writeToLogFile("Error in retrieving data Response..." + res);
                }
            })
            .catch(err => {
                console.log(err)
                setIsLoading(false);
                writeToLogFile("Error in retrieving data... " + err );
            })
    }

    const loadEditDetails = (event) => {
        setEditDetailsGridShow(!editDetailsGridShow);
    }

    const onSubmit = (data) => {
        writeToLogFile("onSubmit() call ");
        if (editFormData?.awv_backend_id && editFormData?.awv_backend_id != '') {
            setFormSubmitisLoading(true);
            data.awv_backend_id = data.awv_backend_id ? data.awv_backend_id.toString() : '';
            if (data.pos_name == null)
                data.pos_name = "";

            data.action_status = data.action_status.toString();


            data.form_status = data.stagechange ? data.stagechange.toString() : "2";

            // data.form_status = data.form_status.toString();
            data.current_form_status = editFormData?.form_status;

            if (data.form_status == 2 || data.form_status == 3) {
                data.role = '4';
            } else {
                data.role = data.role.toString();
            }
            writeToLogFile("data: " + data);
            if (data?.lob)
            data.lob = data.lob.toString();            
            writeToLogFile('awv_backend_id before encryption ', data.awv_backend_id)
            data.awv_backend_id =  encrypt(data.awv_backend_id)
            data.cin = encrypt(data.cin)
            data.member_id = encrypt(data.member_id)
            data.provider_id = encrypt(data.provider_id)
            AWVApi.post('/create-awv-remark-record', data)
                .then(res => {
                    setValue('remark', '');
                    setValue('action_status', '');
                    setValue('awv_backend_id', '');
                    setValue('createdOn', '');
                    setValue('lob', '');
                    setValue('user_id', '');
                    setValue('role', '');
                    setValue('reason_code', '');
                    setFormSubmitisLoading(false);
                    toast.success('Remarks added successfully');
                    notificationRightDrawer(false);
                    props.currentAWERightSidebarCloseDatatableReload(true);
                    writeToLogFile("Data retrieved successfully...");
                    setGenerateLog(true)
                })
                .catch(err => {
                    setFormSubmitisLoading(false);
                    toast.error(err?.response?.data?.message);
                    writeToLogFile("Error in retrieving data... " + err );
                    setGenerateLog(true)
                })
        }
    };

    const loadformAWEProcessedRecord = async (cin, awe_display_id) => {
        var awe_backend_id_en = encrypt(props.aweRightSidebarType.awv_backend_id)
        var cin_en = encrypt(cin)
        AWVApi.get('/get-awe-processed-record-details?year=' + props.yearSelect + '&organisation_id=1&lob=' + props.lobSelect + '&cin=' + cin_en
            + '&awe_display_id=' + awe_display_id + '&awv_backend_id=' + awe_backend_id_en)
            .then(res => {
                if (res.data && res.data[0]) {
                    setSecondaryReasonCode(res.data[0].secondary_reason_code_description)
                    setSecondaryReasonText(res.data[0].secondary_reason_text)
                    setOnholdPrimaryReasonCode(res.data[0].onhold_reason_code_description)
                } else {
                    setSecondaryReasonCode('')
                    setSecondaryReasonText('')
                    setOnholdPrimaryReasonCode('')
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
    useEffect(() => {
        // Generate and download log file when logMessages have been updated
        if (logMessages.length > 0  && generateLog === true) {
        LogFileUploadToS3(logMessages,  ACCESS_KEY, SECRET_ACCESS_KEY, process.env.REACT_APP_LOG_BUCKET, "Stage_Change")
        }
    }, [ generateLog === true, logMessages, props.yearSelect, props.AwvId , props.lobSelect]); 

    const onClick = (event, url) => {
        try {
            event.preventDefault();
            axios({
                url: url,
                responseType: "arraybuffer",
                method: "GET",
            }).then((res) => {
                window.location.href = url
            }).catch((err) => {
                // alertTitleClasses(err)
                toast.error('Error while downloading the form');
            })
        } catch (error) {
            toast.error('Error while downloading the form');
        }

    }

    return (
        <div className="diagnosis_code_sidebar offcanvas offcanvas-end show" tabIndex={-1} aria-labelledby="offcanvasRightLabel">
            <div className="offcanvas-header flex_item_cb">
                <h5 id="offcanvasRightLabel" className='fs15'>STAGE CHANGE</h5>
                <Tooltip title="Close">
                    <IconButton type="button" buttonType={"default"} data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => notificationRightDrawer(false)}>
                        <CloseIcon className="w24" />
                    </IconButton>
                </Tooltip>
            </div>
            <Divider />
            <div className="offcanvas-body custom-scrollbar overflow-auto">
                <form onSubmit={handleSubmit(onSubmit)} id="add-verification-model" enctype="multipart/form-data">
                    <div className="flex_item_cb custom_row flex-wrap mb20">
                        <div className="custom_col">
                            <div className="">
                                <h6 className="fs14">CIN/RXID</h6>
                                <p className="fs13 fw500">{editFormData?.cin}</p>
                            </div>
                        </div>
                        <div className="custom_col">
                            <div className="">
                                <h6 className="fs14">AWE ID</h6>
                                <p className="fs13 fw500">{editFormData?.awe_display_id}</p>
                            </div>
                        </div>
                        <div className="custom_col">
                            <div className="">
                                <h6 className="fs14">UPDATED ON</h6>
                                <p className="fs13 fw500">{Moment(editFormData?.updated_on).format("YYYY-MM-DD")}</p>
                            </div>
                        </div>
                        <div className="custom_col">
                            <div className="">
                                <h6 className="fs14">TIME SPENT</h6>
                                <p className="fs13 fw500">{Moment(editFormData?.updated_on).diff(Moment(editFormData?.created_on), 'days') + ' Days'}</p>
                            </div>
                        </div>
                    </div>
                    <div className="mb20">
                        <h6 className="fs14 mb-1">PROGRESS</h6>
                        <div className="flex_item_cs">
                            <label htmlFor="" className="text-grey-100 fs15">{`${Math.round(editFormData?.progress)}%`}</label>
                            <LinearProgress
                                className="flex-grow-1"
                                sx={{
                                    height: 10,
                                    borderRadius: 5,
                                    [`&.${linearProgressClasses.colorPrimary}`]: {
                                        backgroundColor: [800],
                                    },
                                    [`& .${linearProgressClasses.bar}`]: {
                                        borderRadius: 5,
                                        backgroundColor: '#1a9698',
                                    },
                                }}
                                color="primary"
                                variant="determinate" value={editFormData?.progress} />
                        </div>
                    </div>
                    <Divider className="mb20" />
                    <div className="mb20">
                        <h6 className="fs14 mb-1">DOCUMENT UPLOADED</h6>
                        <div className="">
                            {(fileUrl && editFormData?.form_url && editFormData?.form_url != '') ?
                                <>
                                    {fileUrl && fileUrl.includes(".pdf") ?
                                        <a target="_blank" onClick={(e) => onClick(e, fileUrl)} className="flex_item_cs gap8 text-primary fs15 fw600">
                                            <PlusFileIcon className="w24 h24" />
                                            <span>{editFormData?.form_url ? editFormData?.form_url?.split('/').pop() : ''}</span>
                                        </a>
                                        :
                                        <a onClick={(e) => onClick(e, fileUrl)} target="_blank" download className="flex_item_cs gap8 text-primary fs15 fw600">
                                            <PlusFileIcon className="w24 h24" />
                                            <span>{editFormData?.form_url ? editFormData?.form_url?.split('/').pop() : ''}</span>
                                        </a>
                                    }
                                </>
                                :
                                <></>
                            }
                        </div>
                    </div>
                    <Divider className="mb20" />
                    {onholdPrimaryReasonCode && onholdPrimaryReasonCode !== '' ? (
                        <div className="mb20">
                            <h6 className="fs14">On-hold Primary Reason Code</h6>
                            <p className="fs13 fw500">{onholdPrimaryReasonCode}</p>
                        </div>
                    ) : null}

                    {(secondaryReasonText !="" || secondaryReasonCode !="") ? (
                        <>
                            <div className="mb20">
                                <h6 className="fs14">On-hold Secondary Reason Code</h6>
                                <p className="fs13 fw500">
                                    {secondaryReasonText !=""
                                        ? secondaryReasonText
                                        : secondaryReasonCode}
                                </p>
                            </div>
                            <Divider className="mb20" />
                        </>
                    ) : null}
                    
                    <div>
                        {(editFormData?.form_status) ?
                            <div className="form-group mb20">
                                <label htmlFor="" className="text_c3A3C40 fs13 mb-2">STAGE CHANGE</label>
                                <Controller
                                    name="stagechange"
                                    value={editFormData?.stagechange}
                                    control={control}
                                    render={({ field }) => (
                                        editFormData?.form_status && editFormData?.form_status === "ApprovedForPayment" ?
                                            <select
                                                {...field}
                                                className="form-control"
                                            >
                                                <option value={''} >
                                                    Select
                                                </option>
                                                <option value={"4"}>pendingForPaymentApproval</option>
                                                <option value={'3'}>pendingforCoder</option>
                                                <option value={'2'}>pendingForCoordinator</option>
                                            </select>
                                            :
                                            editFormData?.form_status && editFormData?.form_status === "ApprovedNoPayment" ?
                                                <select
                                                    {...field}
                                                    className="form-control"
                                                >
                                                    <option value={''} >
                                                        Select
                                                    </option>
                                                    <option value={'3'}>pendingforCoder</option>
                                                    <option value={'2'}>pendingForCoordinator</option>
                                                </select>
                                                :
                                                editFormData?.form_status && editFormData?.form_status === "pendingForPaymentApproval" ?
                                                    <select
                                                        {...field}
                                                        className="form-control"
                                                    >
                                                        <option value={''} >
                                                            Select
                                                        </option>
                                                        <option value={'3'}>pendingforCoder</option>
                                                        <option value={'2'}>pendingForCoordinator</option>
                                                    </select>
                                                    :
                                                    editFormData?.form_status && editFormData?.form_status === "pendingforCoder" ?
                                                        <select
                                                            {...field}
                                                            className="form-control"
                                                        >
                                                            <option value={''} >
                                                                Select
                                                            </option>
                                                            <option value={'2'}>pendingForCoordinator</option>
                                                        </select>
                                                        : editFormData?.form_status && editFormData?.form_status === "pendingforCoordinator" ?
                                                            <select
                                                                {...field}
                                                                className="form-control"
                                                            >
                                                                <option value={''} >
                                                                    Select
                                                                </option>

                                                            </select>
                                                            :
                                                            <></>
                                    )}
                                    rules={{
                                        required: true,
                                    }}
                                />
                                {errors?.stagechange?.type === "required" && <label className="form-input-error">This field is required</label>}
                            </div>
                            : editFormData?.POS && editFormData?.POS != '' ?
                                <div className="form-group mb20">
                                    <label htmlFor="" className="text_c3A3C40 fs13 mb-2">PLACE OF SERVICE</label>
                                    <div>{editFormData?.POS}</div>
                                </div>
                                :
                                <></>
                        }
                    </div>
                    <div className="form-group mb20">
                        <label htmlFor="" className="text_c3A3C40 fs13 mb-2">REMARK</label>
                        <Controller
                            name="remark"
                            control={control}
                            render={({ field }) => (
                                <textarea rows={3} {...field} className="form-control" />
                            )}
                            rules={{
                                required: false,
                            }}
                        />
                        {errors?.remark?.type === "required" && <label className="form-input-error">This field is required</label>}
                    </div>
                    <div className="form-group flex_item_cs gap10">
                        <Button type='button' className={"btn-white minw80"} onClick={() => notificationRightDrawer(false)}>CANCEL</Button>
                        <Button type='submit' className={"minw80"} disabled={formSubmitisLoading && formSubmitisLoading == true ? true : false}>STAGE CHANGE</Button>
                    </div>
                </form>
            </div>
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        yearSelect: state.moduleFilter.yearSelect,
        lobSelect: state.moduleFilter.lobSelect,
        aweRightSidebarType: state.moduleFilter.aweRightSidebarType,
        aweRightSidebar: state.moduleFilter.aweRightSidebar,
    };
}
export default connect(mapStateToProps, { currentAWERightSidebarType, currentAWERightSidebar, currentAWERightSidebarCloseDatatableReload })(StageChange);

